import React from "react";
import Marquee from "react-fast-marquee";

const WORDS = ["SPEED", "AGILITY", "MECHANICS", "RECOVERY", "DISCIPLINE", "POWER"];

export default function KineticMarquee() {
  return (
    <section
      className="relative border-y border-zinc-900 bg-[#0A0A0A] py-8 md:py-10 overflow-hidden"
      data-testid="marquee-section"
    >
      <Marquee speed={60} gradient={false} pauseOnHover>
        <div className="ticker-row px-8">
          {WORDS.concat(WORDS).map((w, i) => (
            <span
              key={i}
              className={`font-display text-6xl md:text-8xl leading-none ${
                i % 2 === 0 ? "outline-text" : "text-white"
              }`}
            >
              {w}
              <span className="text-[#E5B43A] ml-8">✦</span>
            </span>
          ))}
        </div>
      </Marquee>
    </section>
  );
}
